import { IAppState } from '../../redux';

export const selectShowOverlay = (state: IAppState): boolean => {
  const { cadastralNumber, buildingCadastralNumber } = state.rosreestrData.cadastralFieldsMeta;

  return cadastralNumber.isChecking || buildingCadastralNumber.isChecking;
};
